import React from "react";
import styles from "./news.module.css";
import Navbar from "../../Components/Navbar/Navbar";
import { Col, Container, Row } from "react-bootstrap";
import {
  Heading,
  Paragraph,
} from "../../Components/TextComponents/TextComponents";
import Insights from "../../Components/Insights/Insights";
import { IoDocumentTextOutline } from "react-icons/io5";
// import RecentNews from "../../Components/RecentNews/RecentNews";
import Highlights from "../../Components/RecentNews/Highlight";
const News = () => {
  const data = [
    {
      title: "2024 Global Renewable Energy Trends",
      description:
        "Market analysis, emerging technologies, and future predictions.",
      image: "/images/news/wind.png",
    },
    {
      title: "2Sustainability in Global Trade: The Next Frontier",
      description:
        "Practical strategies for businesses to integrate sustainability.",
      image: "/images/news/col.png",
    },
  ];
  return (
    <React.Fragment>
      <div className={styles.main_section}>
        <Navbar />

        <Container>
          <Row>
            <Col md={6} sm={12}>
              <div className={styles.heroSection}>
                <Heading color="#fff">Insights That Matter</Heading>
                <Paragraph color="#fff">
                  Stay updated with the latest news, trends, and innovations
                  shaping global trade and industries.
                </Paragraph>

                <Paragraph color="#fff">
                  Welcome to the CrossBorder BTC Blog—your go-to source for
                  in-depth insights, industry trends, and global updates. Stay
                  ahead with stories that drive change and empower businesses
                  worldwide.
                </Paragraph>
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      <Insights />

      {/* ------------industry-reports----------- */}

      <Container>
        <Heading>
          Industry Reports and <br /> Whitepapers
        </Heading>
        <Paragraph color="#62677A">
          Dive deeper with our expertly curated reports and whitepapers,
          offering <br /> comprehensive insights into key industries and
          markets.
        </Paragraph>

        <Row>
          {data.map((item, index) => (
            <Col md={4} sm={12}>
              <div key={index} className={styles.downlaod_section}>
                <img src={item.image} alt="industry" />
                <div className={styles.overlay}>
                  <IoDocumentTextOutline className="text-white" size={40} />
                </div>
                <h6>{item.title}</h6>
                <p>{item.description}</p>
                <button>Download</button>
              </div>
            </Col>
          ))}
        </Row>

        <Highlights />
      </Container>
    </React.Fragment>
  );
};

export default News;
